import { FormFeedback, FormGroup } from 'reactstrap';
import _ from 'lodash';
import { useFormikContext } from 'formik';
import { asArray } from '../utils/form';

export const useRenderWithBulkErrors = (bulkEditField) => {
  const { errors, touched } = useFormikContext();

  const defaultRenderBulkError = (field) => {
    const bulkError = errors[bulkEditField]?.find((item) => item?.[field])?.[
      field
    ];
    return (
      touched[field] &&
      bulkError && <FormFeedback className="d-block">{bulkError}</FormFeedback>
    );
  };

  const renderWithBulkErrors = (
    field,
    renderBulkError = defaultRenderBulkError,
    // eslint-disable-next-line react/display-name
  ) => ({ formGroupClassName, renderInput, renderError, renderLabel }) => {
    return (
      <FormGroup className={formGroupClassName}>
        {renderLabel()}
        {renderInput()}
        {renderError()}
        {renderBulkError(field)}
      </FormGroup>
    );
  };

  const renderObjectBulkError = (field) => {
    // Touched values for this field (can be an array, string, or object).
    const fieldTouched = _.get(touched, field, []);
    // Whether the field has any touched values.
    const anyTouched = asArray(fieldTouched).some((f) => f === true);

    // Errors for this field (can be an array, string, or object).
    const bulkErrors = errors[bulkEditField]?.find((item) => item[field])?.[
      field
    ];
    // Remove falsy values and uniquify.
    const allErrors = _.uniq(_.compact(asArray(bulkErrors)));

    // Show error messages for all of the fields
    return (
      anyTouched &&
      allErrors.length > 0 && (
        <FormFeedback className="d-block">{allErrors.join(', ')}</FormFeedback>
      )
    );
  };

  return {
    defaultRenderBulkError,
    renderWithBulkErrors,
    renderObjectBulkError,
  };
};
